<template>
  <div class="top-level-menu-status-item-wrapper">
    <div v-bind:class="classes" @click="clicked">
      <div v-bind:class="iconClasses"></div>
      <div class="top-level-menu-status-title">
        <span class="top-level-menu-status-text ellipsis">{{statusItem.availabilityTitle}}</span>
        <span v-bind:class="arrowIconClasses"></span>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "top-level-menu-status-item-view",
    props: {
      statusItem: {
        type: Object
      },
      selectedItem: {
        type: Object
      }
    },
    computed: {
      classes() {
        return {
          'top-level-menu-status-item': true,
          selected: this.statusItem.value === this.selectedItem.value,
        }
      },
      iconClasses() {
        let imageClass;
        if(this.statusItem.imageClass === 'online'){
          imageClass = 'ico-agent-status-online online'
        }
        else if(this.statusItem.imageClass === 'brb'){
          imageClass = 'ico-agent-status-back-soon brb'
        }
        else if(this.statusItem.imageClass === 'away'){
          imageClass = 'ico-agent-status-away away'
        }

        return {
          'top-level-menu-status-icon': true,
          [imageClass]: true
        };
      },
      arrowIconClasses() {
        return {
          'top-level-menu-status-arrow-icon ico-arrow-down': true,
          'hide': !this.statusItem.customReasonsAvailable
        };
      }
    },
    methods: {
      clicked() {
        this.$emit('clicked', this.statusItem);
      }
    }
  }
</script>

<style lang='scss' scoped>
  .away {}
  .online {}
  .brb {}

</style>
